import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskUnassignedTicketTypeFieldsRoute: InvariantJiraRoute = {
	exact: true,
	name: 'project-settings-servicedesk-unassigned-ticket-type-fields',
	path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned/request-type/:requestTypeId/:tabKey?',
};
